var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { model: _vm.queryCondition, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("fpaManage.permanent.fpaNo"),
                                    prop: "fpaNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.fpaNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "fpaNo",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.fpaNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Supplier Code",
                                    prop: "supplierCode",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.supplierCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "supplierCode",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.supplierCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Supplier Name",
                                    prop: "supplierAbbreviation",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value:
                                        _vm.queryCondition.supplierAbbreviation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "supplierAbbreviation",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryCondition.supplierAbbreviation",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Status", prop: "status" } },
                                [
                                  _c("ic-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      table: "TT_FPA_PQCN",
                                      field: "REPORT_STATUS",
                                    },
                                    model: {
                                      value: _vm.queryCondition.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "fpaManage.permanent.materialNo"
                                            ),
                                            prop: "materialNo",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "textarea",
                                              rows: 2,
                                              placeholder: _vm.$t(
                                                "fpaManage.permanent.materialNoPlaceHolder"
                                              ),
                                              clearable: "",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.materialNoChange(
                                                  _vm.queryCondition.materialNo
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.materialNo,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "materialNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.materialNo",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "fpaManage.permanent.materialName"
                                            ),
                                            prop: "materialName",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value:
                                                _vm.queryCondition.materialName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "materialName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.materialName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "flexBox",
                                          attrs: {
                                            label: _vm.$t(
                                              "fpaManage.permanent.deadline"
                                            ),
                                            prop: "startDate",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options":
                                                _vm.PickerOptionsStart,
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.startDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.startDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "flexBox",
                                          attrs: {
                                            label: "To",
                                            prop: "endDate",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options":
                                                _vm.PickerOptionsEnd,
                                            },
                                            model: {
                                              value: _vm.queryCondition.endDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.endDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.queryData },
                    },
                    [_vm._v("Search")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.restQueryFormThis },
                    },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "action-btn-row" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.fpaMaterialReportDownload },
            },
            [_vm._v("Download")]
          ),
          _vm._v(
            " " +
              _vm._s(_vm.$t("fpaManage.permanent.materialToExpireCount")) +
              " : " +
              _vm._s(_vm.toExpireCount) +
              "  , " +
              _vm._s(
                _vm.$t("fpaManage.permanent.materialSixMonthExpireCount")
              ) +
              " : " +
              _vm._s(_vm.sixExpiredCount) +
              "  , " +
              _vm._s(_vm.$t("fpaManage.permanent.materialExpiredCount")) +
              " : " +
              _vm._s(_vm.expiredCount) +
              " "
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableFpaMaterialList",
          attrs: {
            data: _vm.tableFpaMaterialList,
            border: "",
            "highlight-current-row": "",
            "max-height": "420",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "fpaNo",
              label: _vm.$t("fpaManage.permanent.fpaNo"),
              width: "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "supplierCode",
              label: "Supplier Code",
              width: "120px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "supplierName",
              label: "Supplier Name",
              "max-width": "15px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "facilityCode",
              label: "Facility Code",
              width: "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "facilityName",
              label: "Facility Name",
              "max-width": "15px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "materialNo",
              label: _vm.$t("fpaManage.permanent.materialNo"),
              "max-width": "15px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "materialName",
              label: _vm.$t("fpaManage.permanent.materialName"),
              "max-width": "15px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "agreementStartDate",
              label: "Start Date",
              width: "100px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.agreementStartDate,
                            "YYYY-MM-DD"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "agreementEndDate",
              label: "End Date",
              width: "100px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.agreementEndDate,
                            "YYYY-MM-DD"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "status",
              label: "Status",
              "min-width": "50px",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageNumberChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }